<template>
  <v-content>
    <router-view />

    <parent-core-footer />
  </v-content>
</template>

<script>
  export default {
    name: 'ParentCoreView',

    components: {
      ParentCoreFooter: () => import('./Footer'),
    },
  }
</script>
